import { render, staticRenderFns } from "./chatForm.vue?vue&type=template&id=b3fab6ac&scoped=true&"
import script from "./chatForm.vue?vue&type=script&lang=js&"
export * from "./chatForm.vue?vue&type=script&lang=js&"
import style0 from "./chatForm.vue?vue&type=style&index=0&id=b3fab6ac&prod&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3fab6ac",
  null
  
)

export default component.exports